/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_SettingsInputs */

const en_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom Settings`)
};

const fr_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de zoom`)
};

const de_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom-Einstellungen`)
};

const it_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni dello zoom`)
};

const ru_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки масштабирования`)
};

const es_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de zoom`)
};

const zh_cn2_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩放设置`)
};

const ja_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズーム設定`)
};

const hi_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम सेटिंग्स`)
};

const pt_pt2_zoom_settings = /** @type {(inputs: Zoom_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de zoom`)
};

/**
* | output |
* | --- |
* | "Zoom Settings" |
*
* @param {Zoom_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_settings = /** @type {((inputs?: Zoom_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom_settings(inputs)
	if (locale === "de") return de_zoom_settings(inputs)
	if (locale === "it") return it_zoom_settings(inputs)
	if (locale === "ru") return ru_zoom_settings(inputs)
	if (locale === "es") return es_zoom_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom_settings(inputs)
	if (locale === "ja") return ja_zoom_settings(inputs)
	if (locale === "hi") return hi_zoom_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom_settings(inputs)
	return en_zoom_settings(inputs)
});